import {
  getCompanies,
  getCompanyMessage,
  updateCompanyMessage,
} from '@/services/company-service/company-service';
import { UpdateCompanyMessage } from '@/services/company-service/company-service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useCompanyInitialMessage = (companyName: string | undefined) => {
  const { data: companyMessage, isLoading } = useQuery({
    queryKey: ReactQueryKeys.INIT_MESS(companyName),
    queryFn: () => getCompanyMessage(companyName!),
    enabled: !!companyName,
  });

  return {
    companyMessage,
    isLoading,
  };
};

export const useUpdateCompanyMessage = (companyName: string | undefined) => {
  const queryClient = useQueryClient();

  const { mutate: updateCompanyMess, isPending: isPendingUpdate } = useMutation({
    mutationFn: (data: UpdateCompanyMessage) => updateCompanyMessage(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ReactQueryKeys.INIT_MESS(companyName),
      });
    },
  });

  return {
    updateCompanyMess,
    isPendingUpdate,
  };
};

export const useCompaniesList = () => {
  const { data: companies } = useQuery({
    queryKey: ReactQueryKeys.COMPANIES(),
    queryFn: () => getCompanies(),
  });

  return {
    companies,
  };
};
